module.exports = __webpack_public_path__ + "img/10_18.29fdfb85.png";